import { render } from "./drop-down-2.vue?vue&type=template&id=13ca7e0e&ts=true"
import script from "./drop-down-2.vue?vue&type=script&lang=ts"
export * from "./drop-down-2.vue?vue&type=script&lang=ts"

import "./drop-down-2.vue?vue&type=style&index=0&id=13ca7e0e&lang=scss"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__